// @ts-nocheck
/**
 * 会員ポイント/ランクの表示更新
 */

const SELECTORS = {
  pointSource: ".js-point-value",
  rankSource: ".js-rank-value",
  pointTarget: ".p-account-point__point-value",
  rankTarget: ".p-account-point__rank-name",
  rankRateTarget: ".p-account-point__rank-rate",
};

const APP_SELECTORS = {
  rankBlock: '.mrpoint-customer[data-block-type="myrank"]',
  pointBlock: '.mrpoint-customer[data-block-type="mypoint"]',
};

const POINT_DATA_ATTRS = [
  "data-customer-point",
  "data-customer-points",
  "data-customer-point-value",
];

// hinata固有: 表示ランク名に対するポイント付与率
const RANK_RATE_BY_LABEL = {
  ブロンズ: "1",
  シルバー: "2",
  ゴールド: "3",
  プラチナ: "4",
  ダイヤモンド: "5",
  ブラック: "7",
};

const getTextValue = (element) => {
  if (!element || !element.textContent) return "";
  return element.textContent.trim();
};

const getRankValue = () => {
  const rankSource = document.querySelector(SELECTORS.rankSource);
  const rankText = getTextValue(rankSource);
  if (rankText) return rankText;

  const rankBlock = document.querySelector(APP_SELECTORS.rankBlock);
  if (!rankBlock) return "";
  const rankAttr = rankBlock.getAttribute("data-customer-rank");
  if (!rankAttr) return "";
  return rankAttr.trim();
};

const getPointValue = () => {
  const pointSource = document.querySelector(SELECTORS.pointSource);
  const pointText = getTextValue(pointSource);
  if (pointText) return pointText;

  const pointBlock = document.querySelector(APP_SELECTORS.pointBlock);
  if (!pointBlock) return "";

  for (const attr of POINT_DATA_ATTRS) {
    const attrValue = pointBlock.getAttribute(attr);
    if (attrValue?.trim()) {
      return attrValue.trim();
    }
  }

  return "";
};

const getRankRateText = (rankValue) => {
  const normalizedRank = rankValue.replace(/\s+/g, "");
  if (!normalizedRank) return "";

  for (const [label, rate] of Object.entries(RANK_RATE_BY_LABEL)) {
    if (normalizedRank === label || normalizedRank.includes(label)) {
      return `（ポイント付与率${rate}％）`;
    }
  }

  return "";
};

export function initAccountPoint() {
  const pointTarget = document.querySelector(SELECTORS.pointTarget);
  const rankTarget = document.querySelector(SELECTORS.rankTarget);
  const rankRateTarget = document.querySelector(SELECTORS.rankRateTarget);

  if (!pointTarget && !rankTarget && !rankRateTarget) return;

  let appliedPoint = false;
  let appliedRank = false;
  let rafId = 0;
  const OBSERVER_TIMEOUT_MS = 15000;

  const applyValues = () => {
    let pointValue = getPointValue();
    const rankValue = getRankValue();

    if (pointValue && !/pt/i.test(pointValue)) {
      pointValue = `${pointValue} pt`;
    }

    if (pointTarget && pointValue) {
      pointTarget.textContent = pointValue;
      appliedPoint = true;
    }

    if (rankTarget && rankValue) {
      rankTarget.textContent = rankValue;
      appliedRank = true;
    }

    if (rankRateTarget) {
      const rankRateText = getRankRateText(rankValue);
      rankRateTarget.textContent = rankRateText;
    }

    return appliedPoint && appliedRank;
  };

  if (applyValues()) return;

  if (!document.body || typeof MutationObserver === "undefined") return;

  const observer = new MutationObserver(() => {
    if (rafId) return;
    rafId = window.requestAnimationFrame(() => {
      rafId = 0;
      if (applyValues()) observer.disconnect();
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ["data-customer-rank", ...POINT_DATA_ATTRS],
  });

  window.setTimeout(() => {
    observer.disconnect();
  }, OBSERVER_TIMEOUT_MS);
}
